import FredImage from '../images/people/fred.jpeg'
import MiaImage from '../images/people/mia.jpeg'
import BeccaImage from '../images/people/becca.jpeg'
import AbelImage from '../images/people/abel.jpeg'
import ZhuoyuImage from '../images/people/zhuoyu.jpeg'
import HuyImage from '../images/people/huy.jpeg'

import TBDImage from '../images/people/tbd.png'

export const faculty = [{
  name: 'Fred Morstatter',
  image: FredImage,
  link: 'https://www.isi.edu/directory/fredmors/',
}]


// export const researchers = [{
//   name: 'Goran Murić',
//   image: 'http://gmuric.com/images/me.jpg',
//   link: 'http://gmuric.com/',
// }, {
//   name: 'Marcin Abram',
//   image: 'https://www.isi.edu/sites/default/files/photos/users/picture-452.jpg',
//   link: 'https://www.isi.edu/people/mjabram/about',
// }]


var _students = [{
  name: 'Zhuoyu Shi',
  image: ZhuoyuImage,
  link: 'https://zhuoyushiii.github.io/',
  tagline: 'Computational Social Science, Social Networks'
}, {
  name: 'Maxyn Leitner',
  image: TBDImage,
  link: 'https://www.isi.edu/directory/maxyn-leitner/',
  tagline: 'Computational Social Science'
}, {
  name: 'Mia Sultan',
  image: MiaImage,
  link: 'https://www.isi.edu/directory/osultan/',
  tagline: 'Persuasion in Forecasting Platforms'
}, ];
_students.sort((a, b) => a['name'].localeCompare(b['name']));
export const students = _students;


var _alumni = [{
  name: 'Ninareh Mehrabi',
  image: 'https://www.isi.edu/wp-content/uploads/headshots/ninarehm-4.jpg',
  link: 'https://ninarehm.github.io/',
  tagline: 'PhD in CS (2022). Disseration Title: Responsible Artificial Intelligence for a Complex World'
}, {
  name: 'Huy Tran Nghiem',
  image: HuyImage,
  link: 'https://www.isi.edu/directory/ninarehm/',
  tagline: 'Masters in CS (2023). Hate Speech Detection'
}, {
  name: 'Myrl Marmarelis',
  image: 'https://www.isi.edu/wp-content/uploads/headshots/myrlm-1.jpg',
  link: 'https://myrl.marmarel.is/',
  tagline: 'PhD in CS (2024). Causal Inference. Now at Caltech.'
}, {
  name: 'Yuzhong Huang',
  image: 'http://www.yuzhonghuang.org/images/bio-photo.jpg',
  link: 'http://www.yuzhonghuang.org/',
  tagline: 'PhD in CS (2024). 3D Scene Reconstruction. Now at Hover.io.'
}, {
  name: 'Abel Salinas',
  image: AbelImage,
  link: 'https://www.isi.edu/directory/asalinas/',
  tagline: 'PhD in CS (2026). Biases in LLMs. Co-Founder & CTO, CommonGround Labs.'
}, {
  name: 'Becca Dorn',
  image: BeccaImage,
  link: 'https://www.isi.edu/directory/rdorn/',
  tagline: 'PhD in CS (2026). Dialect Bias in Subjective Tasks. Now at Character.ai.'
}, {
  name: 'James Huang',
  image: TBDImage,
  link: '#',
  tagline: 'PhD in CS (2026). Natural Language Processing. Now at Microsoft.'
}, {
  name: 'Bahareh Harandizadeh',
  image: 'https://www.isi.edu/wp-content/uploads/headshots/harandiz-1.jpg',
  link: 'https://www.isi.edu/directory/harandiz/',
  tagline: 'PhD in CS (2026). Characterizing LLM Harms. Now at Mayo Clinic.'
}, {
  name: 'Ashwin Rao',
  image: TBDImage,
  link: 'https://www.isi.edu/directory/mrao/',
  tagline: 'PhD in CS (2025). Misinformation, Political Partisanship. Postdoc at Harvard University.'
}, {
  name: 'Negar Mokhberian',
  image: TBDImage,
  link: 'https://www.isi.edu/directory/nmokhber/',
  tagline: 'PhD in CS (2026). Perspectivism in Subjective Annotation. Now at Amazon.'
}, {
  name: 'Ali Jalal-Kamali',
  image: TBDImage,
  link: '#',
  tagline: 'PhD in CS (2025).'
}];
_alumni.sort((a, b) => a['name'].localeCompare(b['name']));
export const alumni = _alumni;